import s from './FilterState.module.scss';
import cn from 'classnames';

export default function FilterState({ state, onClear }) {
  if (!Object.values(state).join('')) return null;

  const renderSelectedItem = (type, value) => (
    <div className={s.badge}>
      <span>{type}:</span>
      <span className={s.value}>{value}</span>
      <span
        onClick={onClear}
        className={cn('material-icons', s.closeIcon)}
        role="button"
      >
        close
      </span>
    </div>
  );

  return (
    <div className={s.wrapper}>
      <div className={s.title}>Selected Filters</div>
      <div>
        {state.search && renderSelectedItem('Search Term', state.search)}
        {state.genre && renderSelectedItem('Genre', state.genre)}
        {state.tag && renderSelectedItem('Tag', state.tag)}
        {state.location && renderSelectedItem('Location', state.location)}
      </div>
    </div>
  );
}
